import React from "react";
import Grid from "@material-ui/core/Grid";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {
    amountWithNegativesDataTableTemplate,
    capacityMultipliedOneHundredTemplate,
    numberWithCommaDataTableTemplate,
    priceDataTableTemplate,
    rateWithNegativesMultipliedByOneHundredDataTableTemplate
} from "../../utils/formatters/Numbers";
import HeaderPage from "../../app/Title/SubtitleLabel/SubtitleLabelView";

const GuaranteeData = (props) => {
    return (
        <React.Fragment>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <HeaderPage header="Garantías Asignadas" isBold={true}/>
                </Grid>
                <Grid item xs={12}>
                    <DataTable
                        value={props.guaranteeList}
                        footerColumnGroup={props.footerColumnGroup}
                        resizableColumns={true}
                        columnResizeMode={"fit"}>
                        <Column field="emisora" header="Emisora" style={{textAlign: 'left'}} sortable={true}/>
                        <Column field="tipoValor" header="Tipo Valor" style={{textAlign: 'left'}} sortable={true}/>
                        <Column field="titulos" header="Títulos" style={{textAlign: 'right'}}
                                body={numberWithCommaDataTableTemplate} sortable={true}/>
                        <Column field={(props.loanStatusPV === 'V'||props.loanStatusPV === 'VA') ? "precioVal" : "precioPrestamo"}
                                header="Precio" style={{textAlign: 'right'}}
                                body={priceDataTableTemplate} sortable={true}/>
                        <Column field="importe" header="Importe" style={{textAlign: 'right'}}
                                body={amountWithNegativesDataTableTemplate} sortable={true}/>
                        <Column field="porcentajeRequerido" header="% Aforo" style={{textAlign: 'right'}}
                                body={capacityMultipliedOneHundredTemplate} sortable={true}/>
                        <Column field="porcentajeGarantizado" header="% Garantía" style={{textAlign: 'right'}}
                                body={rateWithNegativesMultipliedByOneHundredDataTableTemplate} sortable={true}/>
                        <Column field="operacion" header="Operación" style={{textAlign: 'left'}} sortable={true}/>
                    </DataTable>
                </Grid>
            </Grid>
        </React.Fragment>
    )
};

export default GuaranteeData;